import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";

const CashBookPage = lazy(() => import("@/pages/tools.cash-book.page"));

export const Route = createFileRoute("/tools/cash-book")({
  component: CashBookPage,
});
